import React, { useRef, useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { GridLines, Headline } from "@shared"
import { css } from "@jsUtils"
import { gsap, Power1 } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { PageSection } from "../PageSection"
import Styles from "./scrollText.module.scss"

gsap.registerPlugin(ScrollTrigger)

const scale = (number, inMin, inMax, outMin, outMax) => {
  return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}

const ScrollTextSection = props => {
  const { swipeTextA, swipeTextB, theme } = props
  const ref = useRef()
  const headlineRef = useRef()
  const answerRef = useRef()
  const proxyRef = useRef({ value: 0 })
  useEffect(() => {
    const tl = new gsap.timeline({
      scrollTrigger: {
        trigger: ref.current,
        pin: false,
        start: "center 90%",
        end: "center 10%",
        scrub: 2
      }
    })
    tl.to(proxyRef.current, {
      value: "1",
      onUpdate: () => {
        let transformValue = (proxyRef.current.value - 0.666) * 3
        if (transformValue < 0) {
          transformValue = 0
        }
        if (headlineRef.current) {
          headlineRef.current.style.transform = `translate3d(${transformValue * -100}vw, 0, 0)`
        }
        const opacity =
          proxyRef.current.value < 0.2
            ? 0
            : proxyRef.current.value > 0.45
            ? 1
            : scale(proxyRef.current.value, 0.2, 0.45, 0, 1)
        if (answerRef.current) {
          answerRef.current.style.opacity = opacity
          answerRef.current.style.transform = `translate3d(0, ${(1 - opacity) * 36}px, 0)`
        }
      }
    })
  }, [headlineRef])

  return (
    <div ref={ref}>
      <PageSection theme={theme} className={css(Styles.section)}>
        <GridLines theme={theme} />

        <div className={Styles.verticalCenter}>
          <div ref={headlineRef}>
            <Headline size={1} className={Styles.headline}>
              {swipeTextA}
            </Headline>
          </div>
          <div ref={answerRef} className={Styles.answer}>
            <Headline
              size={1}
              className={`${Styles.headline} ${Styles.purple}`}
              data-proxy={proxyRef.current.value}
            >
              {swipeTextB}
            </Headline>
          </div>
        </div>
      </PageSection>
    </div>
  )
}

export default ScrollTextSection
